import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AddUserToGroupInput = {
  asAdmin: Scalars['Boolean']['input'];
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ApproveSwapInput = {
  mfaCode?: InputMaybe<Scalars['String']['input']>;
  passkeyApproval?: InputMaybe<Scalars['String']['input']>;
  swapId: Scalars['ID']['input'];
};

export type ApproveWhitelistedAddressInput = {
  id: Scalars['ID']['input'];
  mfaCode?: InputMaybe<Scalars['String']['input']>;
  passkeyApproval?: InputMaybe<Scalars['String']['input']>;
};

export type AssignUserToCompanyInput = {
  companyId: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AuditLog = {
  __typename?: 'AuditLog';
  action: Scalars['String']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  entityId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  newData?: Maybe<Scalars['String']['output']>;
  oldData?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type AuditLogsFilterInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export enum Chain {
  Bch = 'BCH',
  Bsc = 'BSC',
  Btc = 'BTC',
  Eth = 'ETH',
  Fiat = 'FIAT',
  Ltc = 'LTC',
  Polygon = 'POLYGON',
  Solana = 'SOLANA',
  Tron = 'TRON'
}

export type CompaniesConnection = {
  __typename?: 'CompaniesConnection';
  nodes: Array<Company>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompaniesFilterInput = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  hasFunds?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type Company = {
  __typename?: 'Company';
  autoApprove: Scalars['Boolean']['output'];
  balance: Scalars['String']['output'];
  company: Scalars['String']['output'];
  depositRiskThreshold: DepositRiskThreshold;
  folder?: Maybe<Scalars['String']['output']>;
  group: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  groupImageUrl?: Maybe<Scalars['String']['output']>;
  hasBalance: Scalars['Boolean']['output'];
  hasLpTransfer: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  parentCompanyId?: Maybe<Scalars['String']['output']>;
  parentCompanyName?: Maybe<Scalars['String']['output']>;
  tradeType: TradeType;
};

export type CompanyBalance = {
  __typename?: 'CompanyBalance';
  holdings: Array<CompanyHolding>;
  totalUsdValue: Scalars['String']['output'];
};

export type CompanyHolding = {
  __typename?: 'CompanyHolding';
  availableBalance: Scalars['String']['output'];
  balance: Scalars['String']['output'];
  mint: Mint;
  usdValue: Scalars['String']['output'];
};

export type CompanyStats = {
  __typename?: 'CompanyStats';
  address?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  currentMonthlyVolumes: Scalars['String']['output'];
  director?: Maybe<Scalars['String']['output']>;
  flaggedTransactions: Scalars['Int']['output'];
  previousMonthlyVolumes: Scalars['String']['output'];
  registrationNumber?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export enum CompanyStatus {
  Crypto = 'CRYPTO',
  CryptoAndFiat = 'CRYPTO_AND_FIAT',
  Deactivated = 'DEACTIVATED'
}

export type CreateCompanyInput = {
  autoApprove?: InputMaybe<Scalars['Boolean']['input']>;
  groupId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentCompanyId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CompanyStatus>;
};

export type CreateComplianceOfficerInput = {
  email: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type CreateDepositNoteInput = {
  content: Scalars['String']['input'];
  transactionId: Scalars['String']['input'];
};

export type CreateGroupOwnerInput = {
  email: Scalars['String']['input'];
  groupIds: Array<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type CreateSuperAdminInput = {
  email: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type CreateSwapInput = {
  companyId: Scalars['ID']['input'];
  fromAmount: Scalars['String']['input'];
  fromMintId: Scalars['ID']['input'];
  mfaCode?: InputMaybe<Scalars['String']['input']>;
  passkeyApproval?: InputMaybe<Scalars['String']['input']>;
  toAmount: Scalars['String']['input'];
  toMintId: Scalars['ID']['input'];
  whitelistedAddressId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateSwapNoteInput = {
  content: Scalars['String']['input'];
  swapId: Scalars['ID']['input'];
};

export type CreateUserInput = {
  companyIds: Array<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  groupIds: Array<Scalars['ID']['input']>;
  isWhitelisted: Scalars['Boolean']['input'];
  username: Scalars['String']['input'];
};

export type CreateWhitelistedAddressInput = {
  address: Scalars['String']['input'];
  chain: Chain;
  companyId: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export enum Currency {
  Bch = 'BCH',
  Bnb = 'BNB',
  Bsc = 'BSC',
  Btc = 'BTC',
  Eth = 'ETH',
  Ltc = 'LTC',
  Pol = 'POL',
  Sol = 'SOL',
  Tron = 'TRON',
  Trx = 'TRX',
  Usdc = 'USDC',
  Usdt = 'USDT'
}

export type CursorPaginationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DepositNote = {
  __typename?: 'DepositNote';
  author: Scalars['String']['output'];
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  role: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export enum DepositRiskThreshold {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  VeryLow = 'VERY_LOW'
}

export enum DepositStatus {
  Approved = 'APPROVED',
  Completed = 'COMPLETED',
  Initiated = 'INITIATED',
  LpTransferCompleted = 'LP_TRANSFER_COMPLETED',
  LpTransferFailed = 'LP_TRANSFER_FAILED',
  LpTransferInitiated = 'LP_TRANSFER_INITIATED',
  Rejected = 'REJECTED',
  RejectedCompleted = 'REJECTED_COMPLETED',
  RejectedFailed = 'REJECTED_FAILED'
}

export type DepositTransaction = {
  __typename?: 'DepositTransaction';
  amount: Scalars['String']['output'];
  chain: Chain;
  company: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  companyImageUrl?: Maybe<Scalars['String']['output']>;
  creationDate: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  decisionBy?: Maybe<Scalars['String']['output']>;
  decisionDate?: Maybe<Scalars['String']['output']>;
  depositAddress: Scalars['String']['output'];
  depositTransactionHash: Scalars['String']['output'];
  finalizedDate?: Maybe<Scalars['String']['output']>;
  group: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  groupImageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isExternalApi?: Maybe<Scalars['Boolean']['output']>;
  isFlagged: Scalars['Boolean']['output'];
  notes: Array<DepositNote>;
  rejectTransactionHash?: Maybe<Scalars['String']['output']>;
  status: DepositStatus;
  symbol: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type DepositWallet = {
  __typename?: 'DepositWallet';
  address: Scalars['String']['output'];
  chain: Chain;
  currency: Currency;
};

export enum DocumentType {
  BankStatements = 'BANK_STATEMENTS',
  CertificateOfIncorporation = 'CERTIFICATE_OF_INCORPORATION',
  CompanyProofOfAddress = 'COMPANY_PROOF_OF_ADDRESS',
  DirectorId = 'DIRECTOR_ID',
  DirectorProofOfAddress = 'DIRECTOR_PROOF_OF_ADDRESS',
  InternationalWireTransferInformation = 'INTERNATIONAL_WIRE_TRANSFER_INFORMATION',
  RegistryOfDirectors = 'REGISTRY_OF_DIRECTORS'
}

export type FlagDepositInput = {
  depositId: Scalars['String']['input'];
  flagged: Scalars['Boolean']['input'];
};

export type FlagSwapInput = {
  flagged: Scalars['Boolean']['input'];
  swapId: Scalars['String']['input'];
};

export type GetSwapQuoteInput = {
  companyId: Scalars['ID']['input'];
  fromAmount: Scalars['String']['input'];
  fromMintId: Scalars['ID']['input'];
  toMintId: Scalars['ID']['input'];
};

export type Group = {
  __typename?: 'Group';
  admin: Array<Scalars['String']['output']>;
  bps: Scalars['Float']['output'];
  companies: Scalars['Int']['output'];
  defaultDepositRiskThreshold: DepositRiskThreshold;
  groupId: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  liquidityProvider?: Maybe<Scalars['String']['output']>;
  liquidityProviderBps: Scalars['Float']['output'];
  liquidityProviderId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pendingNotifications: Scalars['Int']['output'];
  status: GroupStatus;
  totalFeeBps: Scalars['Float']['output'];
  usdValueOfAvailableBalance: Scalars['String']['output'];
};

export type GroupStats = {
  __typename?: 'GroupStats';
  activeCompanies: Scalars['Int']['output'];
  availableBalance: Scalars['String']['output'];
  currentMonthlyVolumes: Scalars['String']['output'];
  flaggedTransactions: Scalars['Int']['output'];
  pendingDeposits: Scalars['Int']['output'];
  pendingSwaps: Scalars['Int']['output'];
  previousMonthlyVolumes: Scalars['String']['output'];
};

export enum GroupStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED'
}

export type GroupsConnection = {
  __typename?: 'GroupsConnection';
  nodes: Array<Group>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupsFilterInput = {
  status?: InputMaybe<GroupStatus>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type LpFeeTotal = {
  __typename?: 'LpFeeTotal';
  lpId: Scalars['ID']['output'];
  lpName: Scalars['String']['output'];
  totalUsd: Scalars['String']['output'];
  totalUsdRaw: Scalars['Float']['output'];
};

export type Mint = {
  __typename?: 'Mint';
  address?: Maybe<Scalars['String']['output']>;
  chain: Chain;
  decimals: Scalars['Int']['output'];
  displayDecimals: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type MintLpFee = {
  __typename?: 'MintLpFee';
  fee: Scalars['String']['output'];
  lpId: Scalars['ID']['output'];
  lpName: Scalars['String']['output'];
};

export type MintVolume = {
  __typename?: 'MintVolume';
  groupFee: Scalars['String']['output'];
  lpFee: Scalars['String']['output'];
  lpFees: Array<MintLpFee>;
  mint: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  valiantFee: Scalars['String']['output'];
  volume: Scalars['String']['output'];
};

export type MonthlyVolume = {
  __typename?: 'MonthlyVolume';
  lpFees: Array<LpFeeTotal>;
  mints: Array<MintVolume>;
  month: Scalars['String']['output'];
  totalGroupFeeUsd: Scalars['String']['output'];
  totalGroupFeeUsdRaw: Scalars['Float']['output'];
  totalLpFeeUsd: Scalars['String']['output'];
  totalLpFeeUsdRaw: Scalars['Float']['output'];
  totalUsd: Scalars['String']['output'];
  totalUsdRaw: Scalars['Float']['output'];
  totalValiantFeeUsd: Scalars['String']['output'];
  totalValiantFeeUsdRaw: Scalars['Float']['output'];
};

export type MonthlyVolumesConnection = {
  __typename?: 'MonthlyVolumesConnection';
  nodes: Array<MonthlyVolume>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MonthlyVolumesFilterInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addUserToGroup: User;
  approveDeposit: DepositTransaction;
  approveSwap: Swap;
  approveWhitelistedAddress: WhitelistedAddress;
  assignUserToCompany: User;
  createCompany: Company;
  createDepositNote: DepositNote;
  createGroupOwner: User;
  createSwap: Swap;
  createSwapNote: SwapNote;
  createUser: User;
  createWhitelistedAddress: WhitelistedAddress;
  flagDeposit: DepositTransaction;
  flagSwap: Swap;
  logout: Scalars['Boolean']['output'];
  rejectSwap: Swap;
  rejectWhitelistedAddress: WhitelistedAddress;
  removeUserFromCompany: User;
  removeUserFromGroup: User;
  resetMFA: User;
  resetMyPassword: User;
  resetPassword: User;
  updateMe: User;
  updateUser: User;
  updateWhitelistedAddress: WhitelistedAddress;
};


export type MutationAddUserToGroupArgs = {
  input: AddUserToGroupInput;
};


export type MutationApproveDepositArgs = {
  depositId: Scalars['String']['input'];
};


export type MutationApproveSwapArgs = {
  input: ApproveSwapInput;
};


export type MutationApproveWhitelistedAddressArgs = {
  input: ApproveWhitelistedAddressInput;
};


export type MutationAssignUserToCompanyArgs = {
  input: AssignUserToCompanyInput;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


export type MutationCreateDepositNoteArgs = {
  input: CreateDepositNoteInput;
};


export type MutationCreateGroupOwnerArgs = {
  input: CreateGroupOwnerInput;
};


export type MutationCreateSwapArgs = {
  input: CreateSwapInput;
};


export type MutationCreateSwapNoteArgs = {
  input: CreateSwapNoteInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateWhitelistedAddressArgs = {
  input: CreateWhitelistedAddressInput;
};


export type MutationFlagDepositArgs = {
  input: FlagDepositInput;
};


export type MutationFlagSwapArgs = {
  input: FlagSwapInput;
};


export type MutationRejectSwapArgs = {
  input: RejectSwapInput;
};


export type MutationRejectWhitelistedAddressArgs = {
  input: RejectWhitelistedAddressInput;
};


export type MutationRemoveUserFromCompanyArgs = {
  input: RemoveUserFromCompanyInput;
};


export type MutationRemoveUserFromGroupArgs = {
  input: RemoveUserFromGroupInput;
};


export type MutationResetMfaArgs = {
  userId: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  userId: Scalars['String']['input'];
};


export type MutationUpdateMeArgs = {
  input: UpdateMeInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateWhitelistedAddressArgs = {
  input: UpdateWhitelistedAddressInput;
};

export type OperationResult = {
  __typename?: 'OperationResult';
  id?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type PendingWhitelistedAddress = {
  __typename?: 'PendingWhitelistedAddress';
  address: Scalars['String']['output'];
  chain: Chain;
  companyId: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  decisionBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  requester?: Maybe<Requester>;
  status: WhitelistedAddressStatus;
  updatedAt: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  getAllMints: Array<Mint>;
  getAuditLogs: UserAuditLogsConnection;
  getAvailablePairs: Array<TradingPair>;
  getCompanies: Array<Company>;
  getCompany: Company;
  getCompanyBalance: CompanyBalance;
  getCompanyDepositWallets: Array<DepositWallet>;
  getCompanyStats: CompanyStats;
  getCompanyUtxoMempoolActivity: Array<UtxoMempoolActivity>;
  getCompanyWhitelistedAddresses: Array<WhitelistedAddress>;
  getDepositTransaction?: Maybe<DepositTransaction>;
  getGroup: Group;
  getGroupStats: GroupStats;
  getGroups: Array<Group>;
  getMaintenanceMode: Scalars['Boolean']['output'];
  getMe: User;
  getMonthlyVolumes: Array<MonthlyVolume>;
  getPendingWhitelistedAddresses: Array<PendingWhitelistedAddress>;
  getSwap?: Maybe<Swap>;
  getSwapQuote?: Maybe<SwapQuote>;
  getSwaps: UserSwapsConnection;
  getTransactions: UserTransactionsConnection;
  getUser: User;
  getUserLogs: UserLogsConnection;
  getUsers: UsersConnection;
};


export type QueryGetAllMintsArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryGetAuditLogsArgs = {
  filter?: InputMaybe<AuditLogsFilterInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
};


export type QueryGetAvailablePairsArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryGetCompaniesArgs = {
  filter?: InputMaybe<CompaniesFilterInput>;
};


export type QueryGetCompanyArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryGetCompanyBalanceArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryGetCompanyDepositWalletsArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryGetCompanyStatsArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryGetCompanyUtxoMempoolActivityArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryGetCompanyWhitelistedAddressesArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryGetDepositTransactionArgs = {
  transactionId: Scalars['String']['input'];
};


export type QueryGetGroupArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryGetGroupStatsArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryGetGroupsArgs = {
  filter?: InputMaybe<GroupsFilterInput>;
};


export type QueryGetMonthlyVolumesArgs = {
  filter?: InputMaybe<MonthlyVolumesFilterInput>;
};


export type QueryGetPendingWhitelistedAddressesArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryGetSwapArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSwapQuoteArgs = {
  input: GetSwapQuoteInput;
};


export type QueryGetSwapsArgs = {
  filter?: InputMaybe<SwapsFilterInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
};


export type QueryGetTransactionsArgs = {
  filter?: InputMaybe<TransactionsFilterInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
};


export type QueryGetUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUserLogsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUsersArgs = {
  filter?: InputMaybe<UsersFilterInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
};

export type RejectSwapInput = {
  reason: Scalars['String']['input'];
  swapId: Scalars['ID']['input'];
};

export type RejectWhitelistedAddressInput = {
  id: Scalars['ID']['input'];
};

export type RemoveUserFromCompanyInput = {
  companyId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type RemoveUserFromGroupInput = {
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type Requester = {
  __typename?: 'Requester';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  username: Scalars['String']['output'];
};

export type SharedTransaction = {
  __typename?: 'SharedTransaction';
  approvedDate?: Maybe<Scalars['String']['output']>;
  company: Scalars['String']['output'];
  createdDate?: Maybe<Scalars['String']['output']>;
  depositStatus?: Maybe<DepositStatus>;
  finalizedDate?: Maybe<Scalars['String']['output']>;
  group: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isFlagged: Scalars['Boolean']['output'];
  status: TransactionStatus;
  swapStatus?: Maybe<SwapStatus>;
  transaction: TransactionData;
  type: TransactionType;
  user?: Maybe<Scalars['String']['output']>;
};

export type SharedUser = {
  __typename?: 'SharedUser';
  companiesCount: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  groupsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isWhitelisted: Scalars['Boolean']['output'];
  lastActive?: Maybe<Scalars['String']['output']>;
  role: UserRole;
  username: Scalars['String']['output'];
};

export type Swap = {
  __typename?: 'Swap';
  company: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  companyImageUrl?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  decisionAt?: Maybe<Scalars['String']['output']>;
  decisionBy?: Maybe<Scalars['String']['output']>;
  decisionById?: Maybe<Scalars['String']['output']>;
  fromAmount: Scalars['String']['output'];
  fromMint: Mint;
  group: Scalars['String']['output'];
  groupBps: Scalars['Float']['output'];
  groupImageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isExternalApi?: Maybe<Scalars['Boolean']['output']>;
  isFlagged: Scalars['Boolean']['output'];
  lpFee: Scalars['String']['output'];
  lpId: Scalars['Int']['output'];
  lpReference?: Maybe<Scalars['String']['output']>;
  lpWithdrawalTxHash?: Maybe<Scalars['String']['output']>;
  notes: Array<SwapNote>;
  pushoutWithdrawalTxHash?: Maybe<Scalars['String']['output']>;
  requestedBy?: Maybe<Scalars['String']['output']>;
  requestedById?: Maybe<Scalars['String']['output']>;
  showValiantBps: Scalars['Boolean']['output'];
  status: SwapStatus;
  swapGroupBps: Scalars['Float']['output'];
  swapLpBps: Scalars['Float']['output'];
  swapValiantBps: Scalars['Float']['output'];
  toAmount: Scalars['String']['output'];
  toMint: Mint;
  updatedAt: Scalars['String']['output'];
  usdValue?: Maybe<Scalars['String']['output']>;
  whitelistedAddress: Scalars['String']['output'];
};

export type SwapNote = {
  __typename?: 'SwapNote';
  author: Scalars['String']['output'];
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  role: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type SwapQuote = {
  __typename?: 'SwapQuote';
  exchangeRate?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['String']['output']>;
  fromAmount?: Maybe<Scalars['String']['output']>;
  quoteId?: Maybe<Scalars['String']['output']>;
  retryAt?: Maybe<Scalars['String']['output']>;
  status: SwapQuoteStatus;
  toAmount?: Maybe<Scalars['String']['output']>;
  totalFee?: Maybe<Scalars['String']['output']>;
};

export enum SwapQuoteStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export enum SwapStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  PushOutCompleted = 'PUSH_OUT_COMPLETED',
  PushOutFailed = 'PUSH_OUT_FAILED',
  PushOutInitiated = 'PUSH_OUT_INITIATED',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED',
  TradeCompleted = 'TRADE_COMPLETED',
  TradeExecuting = 'TRADE_EXECUTING',
  TradeFailed = 'TRADE_FAILED',
  WithdrawalCompleted = 'WITHDRAWAL_COMPLETED',
  WithdrawalFailed = 'WITHDRAWAL_FAILED',
  WithdrawalInitiated = 'WITHDRAWAL_INITIATED'
}

export type SwapsFilterInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isFlagged?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TransactionStatus>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export enum TradeType {
  Crypto = 'CRYPTO',
  CryptoAndFiat = 'CRYPTO_AND_FIAT',
  Deactivated = 'DEACTIVATED'
}

export type TradingPair = {
  __typename?: 'TradingPair';
  fromMint: Mint;
  toMint: Mint;
};

export type Transaction = {
  __typename?: 'Transaction';
  approvedDate?: Maybe<Scalars['String']['output']>;
  company: Scalars['String']['output'];
  createdDate?: Maybe<Scalars['String']['output']>;
  depositStatus?: Maybe<DepositStatus>;
  finalizedDate?: Maybe<Scalars['String']['output']>;
  group: Scalars['String']['output'];
  groupBps?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isExternalApi?: Maybe<Scalars['Boolean']['output']>;
  isFlagged: Scalars['Boolean']['output'];
  lpId: Scalars['Int']['output'];
  status: TransactionStatus;
  swapGroupBps?: Maybe<Scalars['Float']['output']>;
  swapLpBps?: Maybe<Scalars['Float']['output']>;
  swapStatus?: Maybe<SwapStatus>;
  swapValiantBps?: Maybe<Scalars['Float']['output']>;
  transaction: TransactionData;
  type: TransactionType;
  user?: Maybe<Scalars['String']['output']>;
};

export enum TransactionAction {
  Execute = 'EXECUTE',
  Review = 'REVIEW'
}

export type TransactionData = {
  __typename?: 'TransactionData';
  amount?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  fromCurrency?: Maybe<Scalars['String']['output']>;
  fromCurrencyImage?: Maybe<Scalars['String']['output']>;
  fromNetwork?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  toCurrency?: Maybe<Scalars['String']['output']>;
  toCurrencyImage?: Maybe<Scalars['String']['output']>;
  toNetwork?: Maybe<Scalars['String']['output']>;
};

export enum TransactionStatus {
  Approved = 'APPROVED',
  Awaiting = 'AWAITING',
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum TransactionType {
  Deposit = 'DEPOSIT',
  Trade = 'TRADE'
}

export type TransactionsConnection = {
  __typename?: 'TransactionsConnection';
  nodes: Array<SharedTransaction>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TransactionsFilterInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isFlagged?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TransactionStatus>;
  type?: InputMaybe<TransactionType>;
};

export type UpdateMeInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isWhitelisted?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<UserRole>;
  userId: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWhitelistedAddressInput = {
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  companiesCount: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  emailNotifications?: Maybe<Scalars['Boolean']['output']>;
  groupsCount: Scalars['Int']['output'];
  has2fa: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isWhitelisted: Scalars['Boolean']['output'];
  lastActive?: Maybe<Scalars['String']['output']>;
  role: UserRole;
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type UserAuditLogsConnection = {
  __typename?: 'UserAuditLogsConnection';
  nodes: Array<AuditLog>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserDepositWalletsConnection = {
  __typename?: 'UserDepositWalletsConnection';
  nodes: Array<DepositWallet>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserLog = {
  __typename?: 'UserLog';
  action: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  entityId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserLogsConnection = {
  __typename?: 'UserLogsConnection';
  nodes: Array<UserLog>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum UserRole {
  Compliance = 'COMPLIANCE',
  GroupOwner = 'GROUP_OWNER',
  SuperAdmin = 'SUPER_ADMIN',
  Trader = 'TRADER'
}

export type UserSwapsConnection = {
  __typename?: 'UserSwapsConnection';
  nodes: Array<Swap>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserTransactionsConnection = {
  __typename?: 'UserTransactionsConnection';
  nodes: Array<Transaction>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserWhitelistedAddressesConnection = {
  __typename?: 'UserWhitelistedAddressesConnection';
  nodes: Array<WhitelistedAddress>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UsersConnection = {
  __typename?: 'UsersConnection';
  nodes: Array<SharedUser>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UsersFilterInput = {
  adminOnly?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  excludeGroupId?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type UtxoMempoolActivity = {
  __typename?: 'UtxoMempoolActivity';
  amount: Scalars['String']['output'];
  chain: Chain;
  confirmations: Scalars['Int']['output'];
  currency: Currency;
  id: Scalars['ID']['output'];
  observedAt: Scalars['String']['output'];
  outputIndex: Scalars['Int']['output'];
  status: UtxoMempoolActivityStatus;
  transactionHash: Scalars['String']['output'];
};

export enum UtxoMempoolActivityStatus {
  Confirmed = 'CONFIRMED',
  Mempool = 'MEMPOOL'
}

export type WhitelistedAddress = {
  __typename?: 'WhitelistedAddress';
  address: Scalars['String']['output'];
  chain: Chain;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  decisionBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  requester?: Maybe<Requester>;
  status: WhitelistedAddressStatus;
  updatedAt: Scalars['String']['output'];
};

export enum WhitelistedAddressStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED'
}

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', getMe: { __typename?: 'User', userId: string, username: string, email: string, has2fa: boolean, id: string, lastActive?: string | null, role: UserRole, isActive: boolean, isWhitelisted: boolean, companiesCount: number, groupsCount: number, emailNotifications?: boolean | null } };

export type GetMaintenanceModeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMaintenanceModeQuery = { __typename?: 'Query', getMaintenanceMode: boolean };

export type GetCompaniesQueryVariables = Exact<{
  filter?: InputMaybe<CompaniesFilterInput>;
}>;


export type GetCompaniesQuery = { __typename?: 'Query', getCompanies: Array<{ __typename?: 'Company', id: string, company: string, group: string, groupId: string, groupImageUrl?: string | null, tradeType: TradeType, imageUrl?: string | null, autoApprove: boolean, balance: string, hasBalance: boolean, hasLpTransfer: boolean }> };

export type GetGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGroupsQuery = { __typename?: 'Query', getGroups: Array<{ __typename?: 'Group', name: string, status: GroupStatus, admin: Array<string>, companies: number, groupId: string, bps: number, imageUrl?: string | null, pendingNotifications: number }> };

export type GetGroupQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type GetGroupQuery = { __typename?: 'Query', getGroup: { __typename?: 'Group', name: string, status: GroupStatus, admin: Array<string>, companies: number, groupId: string, bps: number, imageUrl?: string | null } };

export type GetGroupStatsQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type GetGroupStatsQuery = { __typename?: 'Query', getGroupStats: { __typename?: 'GroupStats', activeCompanies: number, availableBalance: string, pendingSwaps: number, pendingDeposits: number, flaggedTransactions: number, currentMonthlyVolumes: string, previousMonthlyVolumes: string } };

export type GetUsersQueryVariables = Exact<{
  filter?: InputMaybe<UsersFilterInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
}>;


export type GetUsersQuery = { __typename?: 'Query', getUsers: { __typename?: 'UsersConnection', totalCount: number, nodes: Array<{ __typename?: 'SharedUser', id: string, username: string, email: string, role: UserRole, isActive: boolean, isWhitelisted: boolean, lastActive?: string | null, companiesCount: number, groupsCount: number }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetTransactionsQueryVariables = Exact<{
  filter?: InputMaybe<TransactionsFilterInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
}>;


export type GetTransactionsQuery = { __typename?: 'Query', getTransactions: { __typename?: 'UserTransactionsConnection', totalCount: number, nodes: Array<{ __typename?: 'Transaction', id: string, group: string, company: string, user?: string | null, type: TransactionType, status: TransactionStatus, depositStatus?: DepositStatus | null, swapStatus?: SwapStatus | null, groupBps?: number | null, swapGroupBps?: number | null, swapValiantBps?: number | null, lpId: number, createdDate?: string | null, approvedDate?: string | null, finalizedDate?: string | null, isFlagged: boolean, isExternalApi?: boolean | null, transaction: { __typename?: 'TransactionData', from?: string | null, fromCurrency?: string | null, fromNetwork?: string | null, fromCurrencyImage?: string | null, to?: string | null, toCurrency?: string | null, toNetwork?: string | null, toCurrencyImage?: string | null, amount?: string | null, currency?: string | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetMonthlyVolumesQueryVariables = Exact<{
  filter?: InputMaybe<MonthlyVolumesFilterInput>;
}>;


export type GetMonthlyVolumesQuery = { __typename?: 'Query', getMonthlyVolumes: Array<{ __typename?: 'MonthlyVolume', month: string, totalUsd: string, totalUsdRaw: number, mints: Array<{ __typename?: 'MintVolume', mint: string, symbol: string, volume: string }> }> };

export type CreateCompanyMutationVariables = Exact<{
  input: CreateCompanyInput;
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', createCompany: { __typename?: 'Company', id: string } };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: string } };

export type GetCompanyQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type GetCompanyQuery = { __typename?: 'Query', getCompany: { __typename?: 'Company', id: string, company: string, group: string, groupId: string, groupImageUrl?: string | null, tradeType: TradeType, imageUrl?: string | null, autoApprove: boolean, parentCompanyId?: string | null, parentCompanyName?: string | null } };

export type GetCompanyStatsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type GetCompanyStatsQuery = { __typename?: 'Query', getCompanyStats: { __typename?: 'CompanyStats', flaggedTransactions: number, currentMonthlyVolumes: string, previousMonthlyVolumes: string, registrationNumber?: string | null, director?: string | null, country?: string | null, address?: string | null, website?: string | null } };

export type GetCompanyBalanceQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type GetCompanyBalanceQuery = { __typename?: 'Query', getCompanyBalance: { __typename?: 'CompanyBalance', totalUsdValue: string, holdings: Array<{ __typename?: 'CompanyHolding', balance: string, availableBalance: string, usdValue: string, mint: { __typename?: 'Mint', id: string, name: string, symbol: string, decimals: number, displayDecimals: number, address?: string | null, chain: Chain, image?: string | null } }> } };

export type GetAllMintsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type GetAllMintsQuery = { __typename?: 'Query', getAllMints: Array<{ __typename?: 'Mint', id: string, name: string, symbol: string, decimals: number, displayDecimals: number, address?: string | null, chain: Chain, image?: string | null }> };

export type GetAvailablePairsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type GetAvailablePairsQuery = { __typename?: 'Query', getAvailablePairs: Array<{ __typename?: 'TradingPair', fromMint: { __typename?: 'Mint', id: string }, toMint: { __typename?: 'Mint', id: string } }> };

export type GetSwapQuoteQueryVariables = Exact<{
  input: GetSwapQuoteInput;
}>;


export type GetSwapQuoteQuery = { __typename?: 'Query', getSwapQuote?: { __typename?: 'SwapQuote', status: SwapQuoteStatus, retryAt?: string | null, fromAmount?: string | null, toAmount?: string | null, exchangeRate?: string | null, totalFee?: string | null, expiresAt?: string | null, quoteId?: string | null } | null };

export type GetCompanyDepositWalletsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type GetCompanyDepositWalletsQuery = { __typename?: 'Query', getCompanyDepositWallets: Array<{ __typename?: 'DepositWallet', currency: Currency, chain: Chain, address: string }> };

export type GetCompanyUtxoMempoolActivityQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type GetCompanyUtxoMempoolActivityQuery = { __typename?: 'Query', getCompanyUtxoMempoolActivity: Array<{ __typename?: 'UtxoMempoolActivity', id: string, currency: Currency, chain: Chain, amount: string, transactionHash: string, outputIndex: number, status: UtxoMempoolActivityStatus, confirmations: number, observedAt: string }> };

export type GetCompanyWhitelistedAddressesQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type GetCompanyWhitelistedAddressesQuery = { __typename?: 'Query', getCompanyWhitelistedAddresses: Array<{ __typename?: 'WhitelistedAddress', id: string, companyId: string, chain: Chain, address: string, label?: string | null, status: WhitelistedAddressStatus, createdAt: string, updatedAt: string, decisionBy?: string | null, requester?: { __typename?: 'Requester', id: string, username: string, email: string } | null }> };

export type GetPendingWhitelistedAddressesQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type GetPendingWhitelistedAddressesQuery = { __typename?: 'Query', getPendingWhitelistedAddresses: Array<{ __typename?: 'PendingWhitelistedAddress', id: string, companyId: string, companyName: string, chain: Chain, address: string, label?: string | null, status: WhitelistedAddressStatus, createdAt: string, updatedAt: string, decisionBy?: string | null, requester?: { __typename?: 'Requester', id: string, username: string, email: string } | null }> };

export type CreateGroupOwnerMutationVariables = Exact<{
  input: CreateGroupOwnerInput;
}>;


export type CreateGroupOwnerMutation = { __typename?: 'Mutation', createGroupOwner: { __typename?: 'User', id: string } };

export type AddUserToGroupMutationVariables = Exact<{
  input: AddUserToGroupInput;
}>;


export type AddUserToGroupMutation = { __typename?: 'Mutation', addUserToGroup: { __typename?: 'User', id: string, username: string, email: string, role: UserRole, isActive: boolean, isWhitelisted: boolean } };

export type FlagDepositMutationVariables = Exact<{
  input: FlagDepositInput;
}>;


export type FlagDepositMutation = { __typename?: 'Mutation', flagDeposit: { __typename?: 'DepositTransaction', id: string, status: DepositStatus, type: string, currency: string, symbol: string, chain: Chain, amount: string, user: string, company: string, companyId: string, group: string, groupId: string, decisionBy?: string | null, transactionId: string, creationDate: string, decisionDate?: string | null, finalizedDate?: string | null, depositTransactionHash: string, depositAddress: string, isFlagged: boolean, notes: Array<{ __typename?: 'DepositNote', id: string, author: string, role: string, timestamp: string, content: string }> } };

export type FlagSwapMutationVariables = Exact<{
  input: FlagSwapInput;
}>;


export type FlagSwapMutation = { __typename?: 'Mutation', flagSwap: { __typename?: 'Swap', id: string, companyId: string, company: string, group: string, requestedById?: string | null, requestedBy?: string | null, decisionById?: string | null, decisionBy?: string | null, fromAmount: string, toAmount: string, lpFee: string, usdValue?: string | null, status: SwapStatus, lpReference?: string | null, lpWithdrawalTxHash?: string | null, pushoutWithdrawalTxHash?: string | null, createdAt: string, updatedAt: string, decisionAt?: string | null, completedAt?: string | null, whitelistedAddress: string, isFlagged: boolean, fromMint: { __typename?: 'Mint', id: string, name: string, symbol: string, decimals: number, displayDecimals: number, address?: string | null, chain: Chain, image?: string | null }, toMint: { __typename?: 'Mint', id: string, name: string, symbol: string, decimals: number, displayDecimals: number, address?: string | null, chain: Chain, image?: string | null }, notes: Array<{ __typename?: 'SwapNote', id: string, author: string, role: string, timestamp: string, content: string }> } };

export type ApproveDepositMutationVariables = Exact<{
  depositId: Scalars['String']['input'];
}>;


export type ApproveDepositMutation = { __typename?: 'Mutation', approveDeposit: { __typename?: 'DepositTransaction', id: string, status: DepositStatus, type: string, currency: string, symbol: string, chain: Chain, amount: string, user: string, company: string, companyId: string, group: string, groupId: string, decisionBy?: string | null, transactionId: string, creationDate: string, decisionDate?: string | null, finalizedDate?: string | null, depositTransactionHash: string, depositAddress: string, isFlagged: boolean, notes: Array<{ __typename?: 'DepositNote', id: string, author: string, role: string, timestamp: string, content: string }> } };

export type UpdateMeMutationVariables = Exact<{
  input: UpdateMeInput;
}>;


export type UpdateMeMutation = { __typename?: 'Mutation', updateMe: { __typename?: 'User', userId: string, username: string, email: string, has2fa: boolean, id: string, lastActive?: string | null, role: UserRole, isActive: boolean, isWhitelisted: boolean, companiesCount: number, groupsCount: number, emailNotifications?: boolean | null } };

export type ResetMyPasswordMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetMyPasswordMutation = { __typename?: 'Mutation', resetMyPassword: { __typename?: 'User', userId: string, username: string, email: string, has2fa: boolean } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type GetUserQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', getUser: { __typename?: 'User', userId: string, username: string, email: string, has2fa: boolean, id: string, lastActive?: string | null, role: UserRole, isActive: boolean, isWhitelisted: boolean, companiesCount: number, groupsCount: number, emailNotifications?: boolean | null } };

export type GetUserLogsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetUserLogsQuery = { __typename?: 'Query', getUserLogs: { __typename?: 'UserLogsConnection', totalCount: number, nodes: Array<{ __typename?: 'UserLog', id: string, userId?: string | null, user?: string | null, action: string, entityId: string, ipAddress?: string | null, userAgent?: string | null, createdAt: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetSwapsQueryVariables = Exact<{
  filter?: InputMaybe<SwapsFilterInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
}>;


export type GetSwapsQuery = { __typename?: 'Query', getSwaps: { __typename?: 'UserSwapsConnection', totalCount: number, nodes: Array<{ __typename?: 'Swap', id: string, companyId: string, company: string, group: string, requestedById?: string | null, requestedBy?: string | null, decisionById?: string | null, decisionBy?: string | null, fromAmount: string, toAmount: string, lpFee: string, groupBps: number, swapGroupBps: number, swapValiantBps: number, showValiantBps: boolean, lpId: number, usdValue?: string | null, status: SwapStatus, lpReference?: string | null, lpWithdrawalTxHash?: string | null, pushoutWithdrawalTxHash?: string | null, createdAt: string, updatedAt: string, decisionAt?: string | null, completedAt?: string | null, whitelistedAddress: string, isFlagged: boolean, isExternalApi?: boolean | null, fromMint: { __typename?: 'Mint', id: string, name: string, symbol: string, decimals: number, displayDecimals: number, address?: string | null, chain: Chain, image?: string | null }, toMint: { __typename?: 'Mint', id: string, name: string, symbol: string, decimals: number, displayDecimals: number, address?: string | null, chain: Chain, image?: string | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type ApproveSwapMutationVariables = Exact<{
  input: ApproveSwapInput;
}>;


export type ApproveSwapMutation = { __typename?: 'Mutation', approveSwap: { __typename?: 'Swap', id: string, status: SwapStatus, fromAmount: string, toAmount: string } };

export type RejectSwapMutationVariables = Exact<{
  input: RejectSwapInput;
}>;


export type RejectSwapMutation = { __typename?: 'Mutation', rejectSwap: { __typename?: 'Swap', id: string, status: SwapStatus, fromAmount: string, toAmount: string } };

export type GetUserSwapTransactionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserSwapTransactionQuery = { __typename?: 'Query', getSwap?: { __typename?: 'Swap', id: string, companyId: string, company: string, companyImageUrl?: string | null, group: string, groupImageUrl?: string | null, requestedById?: string | null, requestedBy?: string | null, decisionById?: string | null, decisionBy?: string | null, fromAmount: string, toAmount: string, lpFee: string, groupBps: number, swapGroupBps: number, swapValiantBps: number, showValiantBps: boolean, usdValue?: string | null, status: SwapStatus, lpReference?: string | null, lpWithdrawalTxHash?: string | null, pushoutWithdrawalTxHash?: string | null, createdAt: string, updatedAt: string, decisionAt?: string | null, completedAt?: string | null, whitelistedAddress: string, isFlagged: boolean, isExternalApi?: boolean | null, fromMint: { __typename?: 'Mint', id: string, name: string, symbol: string, decimals: number, displayDecimals: number, address?: string | null, chain: Chain, image?: string | null }, toMint: { __typename?: 'Mint', id: string, name: string, symbol: string, decimals: number, displayDecimals: number, address?: string | null, chain: Chain, image?: string | null } } | null };

export type GetUserDepositTransactionQueryVariables = Exact<{
  transactionId: Scalars['String']['input'];
}>;


export type GetUserDepositTransactionQuery = { __typename?: 'Query', getDepositTransaction?: { __typename?: 'DepositTransaction', id: string, status: DepositStatus, type: string, currency: string, symbol: string, chain: Chain, amount: string, user: string, company: string, companyId: string, companyImageUrl?: string | null, group: string, groupId: string, groupImageUrl?: string | null, decisionBy?: string | null, transactionId: string, creationDate: string, decisionDate?: string | null, finalizedDate?: string | null, depositTransactionHash: string, rejectTransactionHash?: string | null, depositAddress: string, isFlagged: boolean, isExternalApi?: boolean | null } | null };

export type CreateUserSwapNoteMutationVariables = Exact<{
  input: CreateSwapNoteInput;
}>;


export type CreateUserSwapNoteMutation = { __typename?: 'Mutation', createSwapNote: { __typename?: 'SwapNote', id: string, author: string, role: string, timestamp: string, content: string } };

export type CreateUserDepositNoteMutationVariables = Exact<{
  input: CreateDepositNoteInput;
}>;


export type CreateUserDepositNoteMutation = { __typename?: 'Mutation', createDepositNote: { __typename?: 'DepositNote', id: string, author: string, role: string, timestamp: string, content: string } };

export type CreateSwapMutationVariables = Exact<{
  input: CreateSwapInput;
}>;


export type CreateSwapMutation = { __typename?: 'Mutation', createSwap: { __typename?: 'Swap', id: string, companyId: string, fromAmount: string, toAmount: string, status: SwapStatus, fromMint: { __typename?: 'Mint', id: string, symbol: string }, toMint: { __typename?: 'Mint', id: string, symbol: string } } };

export type CreateWhitelistedAddressMutationVariables = Exact<{
  input: CreateWhitelistedAddressInput;
}>;


export type CreateWhitelistedAddressMutation = { __typename?: 'Mutation', createWhitelistedAddress: { __typename?: 'WhitelistedAddress', id: string, companyId: string, chain: Chain, address: string, label?: string | null, status: WhitelistedAddressStatus, createdAt: string, updatedAt: string, decisionBy?: string | null } };

export type ApproveWhitelistedAddressMutationVariables = Exact<{
  input: ApproveWhitelistedAddressInput;
}>;


export type ApproveWhitelistedAddressMutation = { __typename?: 'Mutation', approveWhitelistedAddress: { __typename?: 'WhitelistedAddress', id: string, companyId: string, chain: Chain, address: string, label?: string | null, status: WhitelistedAddressStatus, createdAt: string, updatedAt: string, decisionBy?: string | null } };

export type RejectWhitelistedAddressMutationVariables = Exact<{
  input: RejectWhitelistedAddressInput;
}>;


export type RejectWhitelistedAddressMutation = { __typename?: 'Mutation', rejectWhitelistedAddress: { __typename?: 'WhitelistedAddress', id: string, companyId: string, chain: Chain, address: string, label?: string | null, status: WhitelistedAddressStatus, createdAt: string, updatedAt: string, decisionBy?: string | null } };

export type UpdateWhitelistedAddressMutationVariables = Exact<{
  input: UpdateWhitelistedAddressInput;
}>;


export type UpdateWhitelistedAddressMutation = { __typename?: 'Mutation', updateWhitelistedAddress: { __typename?: 'WhitelistedAddress', id: string, companyId: string, chain: Chain, address: string, label?: string | null, status: WhitelistedAddressStatus, createdAt: string, updatedAt: string } };

export type GetAuditLogsQueryVariables = Exact<{
  filter?: InputMaybe<AuditLogsFilterInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
}>;


export type GetAuditLogsQuery = { __typename?: 'Query', getAuditLogs: { __typename?: 'UserAuditLogsConnection', totalCount: number, nodes: Array<{ __typename?: 'AuditLog', id: string, userId?: string | null, user?: string | null, action: string, entityId: string, oldData?: string | null, newData?: string | null, companyName?: string | null, ipAddress?: string | null, userAgent?: string | null, createdAt: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, username: string, email: string, lastActive?: string | null, role: UserRole, isActive: boolean, isWhitelisted: boolean, companiesCount: number, groupsCount: number, emailNotifications?: boolean | null } };

export type ResetPasswordMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'User', userId: string, username: string, email: string, has2fa: boolean } };

export type ResetMfaMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ResetMfaMutation = { __typename?: 'Mutation', resetMFA: { __typename?: 'User', userId: string, username: string, email: string, has2fa: boolean } };

export type AssignUserToCompanyMutationVariables = Exact<{
  input: AssignUserToCompanyInput;
}>;


export type AssignUserToCompanyMutation = { __typename?: 'Mutation', assignUserToCompany: { __typename?: 'User', id: string, username: string, email: string, lastActive?: string | null, role: UserRole, isActive: boolean, isWhitelisted: boolean, companiesCount: number, groupsCount: number, emailNotifications?: boolean | null } };

export type RemoveUserFromCompanyMutationVariables = Exact<{
  input: RemoveUserFromCompanyInput;
}>;


export type RemoveUserFromCompanyMutation = { __typename?: 'Mutation', removeUserFromCompany: { __typename?: 'User', id: string, username: string, email: string, lastActive?: string | null, role: UserRole, isActive: boolean, isWhitelisted: boolean, companiesCount: number, groupsCount: number, emailNotifications?: boolean | null } };

export type RemoveUserFromGroupMutationVariables = Exact<{
  input: RemoveUserFromGroupInput;
}>;


export type RemoveUserFromGroupMutation = { __typename?: 'Mutation', removeUserFromGroup: { __typename?: 'User', id: string, username: string, email: string, lastActive?: string | null, role: UserRole, isActive: boolean, isWhitelisted: boolean, companiesCount: number, groupsCount: number, emailNotifications?: boolean | null } };


export const GetMeDocument = gql`
    query getMe {
  getMe {
    userId
    username
    email
    has2fa
    id
    lastActive
    role
    isActive
    isWhitelisted
    companiesCount
    groupsCount
    emailNotifications
  }
}
    `;

export function useGetMeQuery(options?: Omit<Urql.UseQueryArgs<GetMeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMeQuery, GetMeQueryVariables>({ query: GetMeDocument, ...options });
};
export const GetMaintenanceModeDocument = gql`
    query GetMaintenanceMode {
  getMaintenanceMode
}
    `;

export function useGetMaintenanceModeQuery(options?: Omit<Urql.UseQueryArgs<GetMaintenanceModeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMaintenanceModeQuery, GetMaintenanceModeQueryVariables>({ query: GetMaintenanceModeDocument, ...options });
};
export const GetCompaniesDocument = gql`
    query getCompanies($filter: CompaniesFilterInput) {
  getCompanies(filter: $filter) {
    id
    company
    group
    groupId
    groupImageUrl
    tradeType
    imageUrl
    autoApprove
    balance
    hasBalance
    hasLpTransfer
  }
}
    `;

export function useGetCompaniesQuery(options?: Omit<Urql.UseQueryArgs<GetCompaniesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCompaniesQuery, GetCompaniesQueryVariables>({ query: GetCompaniesDocument, ...options });
};
export const GetGroupsDocument = gql`
    query getGroups {
  getGroups {
    name
    status
    admin
    companies
    groupId
    bps
    imageUrl
    pendingNotifications
  }
}
    `;

export function useGetGroupsQuery(options?: Omit<Urql.UseQueryArgs<GetGroupsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetGroupsQuery, GetGroupsQueryVariables>({ query: GetGroupsDocument, ...options });
};
export const GetGroupDocument = gql`
    query getGroup($groupId: String!) {
  getGroup(groupId: $groupId) {
    name
    status
    admin
    companies
    groupId
    bps
    imageUrl
  }
}
    `;

export function useGetGroupQuery(options: Omit<Urql.UseQueryArgs<GetGroupQueryVariables>, 'query'>) {
  return Urql.useQuery<GetGroupQuery, GetGroupQueryVariables>({ query: GetGroupDocument, ...options });
};
export const GetGroupStatsDocument = gql`
    query getGroupStats($groupId: String!) {
  getGroupStats(groupId: $groupId) {
    activeCompanies
    availableBalance
    pendingSwaps
    pendingDeposits
    flaggedTransactions
    currentMonthlyVolumes
    previousMonthlyVolumes
  }
}
    `;

export function useGetGroupStatsQuery(options: Omit<Urql.UseQueryArgs<GetGroupStatsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetGroupStatsQuery, GetGroupStatsQueryVariables>({ query: GetGroupStatsDocument, ...options });
};
export const GetUsersDocument = gql`
    query getUsers($filter: UsersFilterInput, $pagination: CursorPaginationInput) {
  getUsers(filter: $filter, pagination: $pagination) {
    nodes {
      id
      username
      email
      role
      isActive
      isWhitelisted
      lastActive
      companiesCount
      groupsCount
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

export function useGetUsersQuery(options?: Omit<Urql.UseQueryArgs<GetUsersQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUsersQuery, GetUsersQueryVariables>({ query: GetUsersDocument, ...options });
};
export const GetTransactionsDocument = gql`
    query getTransactions($filter: TransactionsFilterInput, $pagination: CursorPaginationInput) {
  getTransactions(filter: $filter, pagination: $pagination) {
    nodes {
      id
      group
      company
      user
      type
      status
      depositStatus
      swapStatus
      groupBps
      swapGroupBps
      swapValiantBps
      lpId
      transaction {
        from
        fromCurrency
        fromNetwork
        fromCurrencyImage
        to
        toCurrency
        toNetwork
        toCurrencyImage
        amount
        currency
      }
      createdDate
      approvedDate
      finalizedDate
      isFlagged
      isExternalApi
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

export function useGetTransactionsQuery(options?: Omit<Urql.UseQueryArgs<GetTransactionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTransactionsQuery, GetTransactionsQueryVariables>({ query: GetTransactionsDocument, ...options });
};
export const GetMonthlyVolumesDocument = gql`
    query getMonthlyVolumes($filter: MonthlyVolumesFilterInput) {
  getMonthlyVolumes(filter: $filter) {
    month
    totalUsd
    totalUsdRaw
    mints {
      mint
      symbol
      volume
    }
  }
}
    `;

export function useGetMonthlyVolumesQuery(options?: Omit<Urql.UseQueryArgs<GetMonthlyVolumesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMonthlyVolumesQuery, GetMonthlyVolumesQueryVariables>({ query: GetMonthlyVolumesDocument, ...options });
};
export const CreateCompanyDocument = gql`
    mutation createCompany($input: CreateCompanyInput!) {
  createCompany(input: $input) {
    id
  }
}
    `;

export function useCreateCompanyMutation() {
  return Urql.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument);
};
export const CreateUserDocument = gql`
    mutation createUser($input: CreateUserInput!) {
  createUser(input: $input) {
    id
  }
}
    `;

export function useCreateUserMutation() {
  return Urql.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument);
};
export const GetCompanyDocument = gql`
    query getCompany($companyId: String!) {
  getCompany(companyId: $companyId) {
    id
    company
    group
    groupId
    groupImageUrl
    tradeType
    imageUrl
    autoApprove
    parentCompanyId
    parentCompanyName
  }
}
    `;

export function useGetCompanyQuery(options: Omit<Urql.UseQueryArgs<GetCompanyQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCompanyQuery, GetCompanyQueryVariables>({ query: GetCompanyDocument, ...options });
};
export const GetCompanyStatsDocument = gql`
    query getCompanyStats($companyId: String!) {
  getCompanyStats(companyId: $companyId) {
    flaggedTransactions
    currentMonthlyVolumes
    previousMonthlyVolumes
    registrationNumber
    director
    country
    address
    website
  }
}
    `;

export function useGetCompanyStatsQuery(options: Omit<Urql.UseQueryArgs<GetCompanyStatsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCompanyStatsQuery, GetCompanyStatsQueryVariables>({ query: GetCompanyStatsDocument, ...options });
};
export const GetCompanyBalanceDocument = gql`
    query getCompanyBalance($companyId: String!) {
  getCompanyBalance(companyId: $companyId) {
    totalUsdValue
    holdings {
      mint {
        id
        name
        symbol
        decimals
        displayDecimals
        address
        chain
        image
      }
      balance
      availableBalance
      usdValue
    }
  }
}
    `;

export function useGetCompanyBalanceQuery(options: Omit<Urql.UseQueryArgs<GetCompanyBalanceQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCompanyBalanceQuery, GetCompanyBalanceQueryVariables>({ query: GetCompanyBalanceDocument, ...options });
};
export const GetAllMintsDocument = gql`
    query getAllMints($companyId: String!) {
  getAllMints(companyId: $companyId) {
    id
    name
    symbol
    decimals
    displayDecimals
    address
    chain
    image
  }
}
    `;

export function useGetAllMintsQuery(options: Omit<Urql.UseQueryArgs<GetAllMintsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAllMintsQuery, GetAllMintsQueryVariables>({ query: GetAllMintsDocument, ...options });
};
export const GetAvailablePairsDocument = gql`
    query getAvailablePairs($companyId: String!) {
  getAvailablePairs(companyId: $companyId) {
    fromMint {
      id
    }
    toMint {
      id
    }
  }
}
    `;

export function useGetAvailablePairsQuery(options: Omit<Urql.UseQueryArgs<GetAvailablePairsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAvailablePairsQuery, GetAvailablePairsQueryVariables>({ query: GetAvailablePairsDocument, ...options });
};
export const GetSwapQuoteDocument = gql`
    query getSwapQuote($input: GetSwapQuoteInput!) {
  getSwapQuote(input: $input) {
    status
    retryAt
    fromAmount
    toAmount
    exchangeRate
    totalFee
    expiresAt
    quoteId
  }
}
    `;

export function useGetSwapQuoteQuery(options: Omit<Urql.UseQueryArgs<GetSwapQuoteQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSwapQuoteQuery, GetSwapQuoteQueryVariables>({ query: GetSwapQuoteDocument, ...options });
};
export const GetCompanyDepositWalletsDocument = gql`
    query getCompanyDepositWallets($companyId: ID!) {
  getCompanyDepositWallets(companyId: $companyId) {
    currency
    chain
    address
  }
}
    `;

export function useGetCompanyDepositWalletsQuery(options: Omit<Urql.UseQueryArgs<GetCompanyDepositWalletsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCompanyDepositWalletsQuery, GetCompanyDepositWalletsQueryVariables>({ query: GetCompanyDepositWalletsDocument, ...options });
};
export const GetCompanyUtxoMempoolActivityDocument = gql`
    query getCompanyUtxoMempoolActivity($companyId: ID!) {
  getCompanyUtxoMempoolActivity(companyId: $companyId) {
    id
    currency
    chain
    amount
    transactionHash
    outputIndex
    status
    confirmations
    observedAt
  }
}
    `;

export function useGetCompanyUtxoMempoolActivityQuery(options: Omit<Urql.UseQueryArgs<GetCompanyUtxoMempoolActivityQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCompanyUtxoMempoolActivityQuery, GetCompanyUtxoMempoolActivityQueryVariables>({ query: GetCompanyUtxoMempoolActivityDocument, ...options });
};
export const GetCompanyWhitelistedAddressesDocument = gql`
    query getCompanyWhitelistedAddresses($companyId: String!) {
  getCompanyWhitelistedAddresses(companyId: $companyId) {
    id
    companyId
    chain
    address
    label
    status
    createdAt
    updatedAt
    decisionBy
    requester {
      id
      username
      email
    }
  }
}
    `;

export function useGetCompanyWhitelistedAddressesQuery(options: Omit<Urql.UseQueryArgs<GetCompanyWhitelistedAddressesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCompanyWhitelistedAddressesQuery, GetCompanyWhitelistedAddressesQueryVariables>({ query: GetCompanyWhitelistedAddressesDocument, ...options });
};
export const GetPendingWhitelistedAddressesDocument = gql`
    query getPendingWhitelistedAddresses($groupId: String!) {
  getPendingWhitelistedAddresses(groupId: $groupId) {
    id
    companyId
    companyName
    chain
    address
    label
    status
    createdAt
    updatedAt
    decisionBy
    requester {
      id
      username
      email
    }
  }
}
    `;

export function useGetPendingWhitelistedAddressesQuery(options: Omit<Urql.UseQueryArgs<GetPendingWhitelistedAddressesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPendingWhitelistedAddressesQuery, GetPendingWhitelistedAddressesQueryVariables>({ query: GetPendingWhitelistedAddressesDocument, ...options });
};
export const CreateGroupOwnerDocument = gql`
    mutation createGroupOwner($input: CreateGroupOwnerInput!) {
  createGroupOwner(input: $input) {
    id
  }
}
    `;

export function useCreateGroupOwnerMutation() {
  return Urql.useMutation<CreateGroupOwnerMutation, CreateGroupOwnerMutationVariables>(CreateGroupOwnerDocument);
};
export const AddUserToGroupDocument = gql`
    mutation addUserToGroup($input: AddUserToGroupInput!) {
  addUserToGroup(input: $input) {
    id
    username
    email
    role
    isActive
    isWhitelisted
  }
}
    `;

export function useAddUserToGroupMutation() {
  return Urql.useMutation<AddUserToGroupMutation, AddUserToGroupMutationVariables>(AddUserToGroupDocument);
};
export const FlagDepositDocument = gql`
    mutation flagDeposit($input: FlagDepositInput!) {
  flagDeposit(input: $input) {
    id
    status
    type
    currency
    symbol
    chain
    amount
    user
    company
    companyId
    group
    groupId
    decisionBy
    transactionId
    creationDate
    decisionDate
    finalizedDate
    depositTransactionHash
    depositAddress
    notes {
      id
      author
      role
      timestamp
      content
    }
    isFlagged
  }
}
    `;

export function useFlagDepositMutation() {
  return Urql.useMutation<FlagDepositMutation, FlagDepositMutationVariables>(FlagDepositDocument);
};
export const FlagSwapDocument = gql`
    mutation flagSwap($input: FlagSwapInput!) {
  flagSwap(input: $input) {
    id
    companyId
    company
    group
    requestedById
    requestedBy
    decisionById
    decisionBy
    fromMint {
      id
      name
      symbol
      decimals
      displayDecimals
      address
      chain
      image
    }
    toMint {
      id
      name
      symbol
      decimals
      displayDecimals
      address
      chain
      image
    }
    fromAmount
    toAmount
    lpFee
    usdValue
    status
    lpReference
    lpWithdrawalTxHash
    pushoutWithdrawalTxHash
    createdAt
    updatedAt
    decisionAt
    completedAt
    whitelistedAddress
    isFlagged
    notes {
      id
      author
      role
      timestamp
      content
    }
  }
}
    `;

export function useFlagSwapMutation() {
  return Urql.useMutation<FlagSwapMutation, FlagSwapMutationVariables>(FlagSwapDocument);
};
export const ApproveDepositDocument = gql`
    mutation approveDeposit($depositId: String!) {
  approveDeposit(depositId: $depositId) {
    id
    status
    type
    currency
    symbol
    chain
    amount
    user
    company
    companyId
    group
    groupId
    decisionBy
    transactionId
    creationDate
    decisionDate
    finalizedDate
    depositTransactionHash
    depositAddress
    notes {
      id
      author
      role
      timestamp
      content
    }
    isFlagged
  }
}
    `;

export function useApproveDepositMutation() {
  return Urql.useMutation<ApproveDepositMutation, ApproveDepositMutationVariables>(ApproveDepositDocument);
};
export const UpdateMeDocument = gql`
    mutation updateMe($input: UpdateMeInput!) {
  updateMe(input: $input) {
    userId
    username
    email
    has2fa
    id
    lastActive
    role
    isActive
    isWhitelisted
    companiesCount
    groupsCount
    emailNotifications
  }
}
    `;

export function useUpdateMeMutation() {
  return Urql.useMutation<UpdateMeMutation, UpdateMeMutationVariables>(UpdateMeDocument);
};
export const ResetMyPasswordDocument = gql`
    mutation resetMyPassword {
  resetMyPassword {
    userId
    username
    email
    has2fa
  }
}
    `;

export function useResetMyPasswordMutation() {
  return Urql.useMutation<ResetMyPasswordMutation, ResetMyPasswordMutationVariables>(ResetMyPasswordDocument);
};
export const LogoutDocument = gql`
    mutation logout {
  logout
}
    `;

export function useLogoutMutation() {
  return Urql.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument);
};
export const GetUserDocument = gql`
    query getUser($userId: String!) {
  getUser(userId: $userId) {
    userId
    username
    email
    has2fa
    id
    lastActive
    role
    isActive
    isWhitelisted
    companiesCount
    groupsCount
    emailNotifications
  }
}
    `;

export function useGetUserQuery(options: Omit<Urql.UseQueryArgs<GetUserQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUserQuery, GetUserQueryVariables>({ query: GetUserDocument, ...options });
};
export const GetUserLogsDocument = gql`
    query getUserLogs($userId: String, $pagination: PaginationInput) {
  getUserLogs(userId: $userId, pagination: $pagination) {
    nodes {
      id
      userId
      user
      action
      entityId
      ipAddress
      userAgent
      createdAt
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

export function useGetUserLogsQuery(options?: Omit<Urql.UseQueryArgs<GetUserLogsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUserLogsQuery, GetUserLogsQueryVariables>({ query: GetUserLogsDocument, ...options });
};
export const GetSwapsDocument = gql`
    query getSwaps($filter: SwapsFilterInput, $pagination: CursorPaginationInput) {
  getSwaps(filter: $filter, pagination: $pagination) {
    nodes {
      id
      companyId
      company
      group
      requestedById
      requestedBy
      decisionById
      decisionBy
      fromMint {
        id
        name
        symbol
        decimals
        displayDecimals
        address
        chain
        image
      }
      toMint {
        id
        name
        symbol
        decimals
        displayDecimals
        address
        chain
        image
      }
      fromAmount
      toAmount
      lpFee
      groupBps
      swapGroupBps
      swapValiantBps
      showValiantBps
      lpId
      usdValue
      status
      lpReference
      lpWithdrawalTxHash
      pushoutWithdrawalTxHash
      createdAt
      updatedAt
      decisionAt
      completedAt
      whitelistedAddress
      isFlagged
      isExternalApi
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

export function useGetSwapsQuery(options?: Omit<Urql.UseQueryArgs<GetSwapsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSwapsQuery, GetSwapsQueryVariables>({ query: GetSwapsDocument, ...options });
};
export const ApproveSwapDocument = gql`
    mutation approveSwap($input: ApproveSwapInput!) {
  approveSwap(input: $input) {
    id
    status
    fromAmount
    toAmount
  }
}
    `;

export function useApproveSwapMutation() {
  return Urql.useMutation<ApproveSwapMutation, ApproveSwapMutationVariables>(ApproveSwapDocument);
};
export const RejectSwapDocument = gql`
    mutation rejectSwap($input: RejectSwapInput!) {
  rejectSwap(input: $input) {
    id
    status
    fromAmount
    toAmount
  }
}
    `;

export function useRejectSwapMutation() {
  return Urql.useMutation<RejectSwapMutation, RejectSwapMutationVariables>(RejectSwapDocument);
};
export const GetUserSwapTransactionDocument = gql`
    query getUserSwapTransaction($id: ID!) {
  getSwap(id: $id) {
    id
    companyId
    company
    companyImageUrl
    group
    groupImageUrl
    requestedById
    requestedBy
    decisionById
    decisionBy
    fromMint {
      id
      name
      symbol
      decimals
      displayDecimals
      address
      chain
      image
    }
    toMint {
      id
      name
      symbol
      decimals
      displayDecimals
      address
      chain
      image
    }
    fromAmount
    toAmount
    lpFee
    groupBps
    swapGroupBps
    swapValiantBps
    showValiantBps
    usdValue
    status
    lpReference
    lpWithdrawalTxHash
    pushoutWithdrawalTxHash
    createdAt
    updatedAt
    decisionAt
    completedAt
    whitelistedAddress
    isFlagged
    isExternalApi
  }
}
    `;

export function useGetUserSwapTransactionQuery(options: Omit<Urql.UseQueryArgs<GetUserSwapTransactionQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUserSwapTransactionQuery, GetUserSwapTransactionQueryVariables>({ query: GetUserSwapTransactionDocument, ...options });
};
export const GetUserDepositTransactionDocument = gql`
    query getUserDepositTransaction($transactionId: String!) {
  getDepositTransaction(transactionId: $transactionId) {
    id
    status
    type
    currency
    symbol
    chain
    amount
    user
    company
    companyId
    companyImageUrl
    group
    groupId
    groupImageUrl
    decisionBy
    transactionId
    creationDate
    decisionDate
    finalizedDate
    depositTransactionHash
    rejectTransactionHash
    depositAddress
    isFlagged
    isExternalApi
  }
}
    `;

export function useGetUserDepositTransactionQuery(options: Omit<Urql.UseQueryArgs<GetUserDepositTransactionQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUserDepositTransactionQuery, GetUserDepositTransactionQueryVariables>({ query: GetUserDepositTransactionDocument, ...options });
};
export const CreateUserSwapNoteDocument = gql`
    mutation createUserSwapNote($input: CreateSwapNoteInput!) {
  createSwapNote(input: $input) {
    id
    author
    role
    timestamp
    content
  }
}
    `;

export function useCreateUserSwapNoteMutation() {
  return Urql.useMutation<CreateUserSwapNoteMutation, CreateUserSwapNoteMutationVariables>(CreateUserSwapNoteDocument);
};
export const CreateUserDepositNoteDocument = gql`
    mutation createUserDepositNote($input: CreateDepositNoteInput!) {
  createDepositNote(input: $input) {
    id
    author
    role
    timestamp
    content
  }
}
    `;

export function useCreateUserDepositNoteMutation() {
  return Urql.useMutation<CreateUserDepositNoteMutation, CreateUserDepositNoteMutationVariables>(CreateUserDepositNoteDocument);
};
export const CreateSwapDocument = gql`
    mutation createSwap($input: CreateSwapInput!) {
  createSwap(input: $input) {
    id
    companyId
    fromMint {
      id
      symbol
    }
    toMint {
      id
      symbol
    }
    fromAmount
    toAmount
    status
  }
}
    `;

export function useCreateSwapMutation() {
  return Urql.useMutation<CreateSwapMutation, CreateSwapMutationVariables>(CreateSwapDocument);
};
export const CreateWhitelistedAddressDocument = gql`
    mutation createWhitelistedAddress($input: CreateWhitelistedAddressInput!) {
  createWhitelistedAddress(input: $input) {
    id
    companyId
    chain
    address
    label
    status
    createdAt
    updatedAt
    decisionBy
  }
}
    `;

export function useCreateWhitelistedAddressMutation() {
  return Urql.useMutation<CreateWhitelistedAddressMutation, CreateWhitelistedAddressMutationVariables>(CreateWhitelistedAddressDocument);
};
export const ApproveWhitelistedAddressDocument = gql`
    mutation approveWhitelistedAddress($input: ApproveWhitelistedAddressInput!) {
  approveWhitelistedAddress(input: $input) {
    id
    companyId
    chain
    address
    label
    status
    createdAt
    updatedAt
    decisionBy
  }
}
    `;

export function useApproveWhitelistedAddressMutation() {
  return Urql.useMutation<ApproveWhitelistedAddressMutation, ApproveWhitelistedAddressMutationVariables>(ApproveWhitelistedAddressDocument);
};
export const RejectWhitelistedAddressDocument = gql`
    mutation rejectWhitelistedAddress($input: RejectWhitelistedAddressInput!) {
  rejectWhitelistedAddress(input: $input) {
    id
    companyId
    chain
    address
    label
    status
    createdAt
    updatedAt
    decisionBy
  }
}
    `;

export function useRejectWhitelistedAddressMutation() {
  return Urql.useMutation<RejectWhitelistedAddressMutation, RejectWhitelistedAddressMutationVariables>(RejectWhitelistedAddressDocument);
};
export const UpdateWhitelistedAddressDocument = gql`
    mutation updateWhitelistedAddress($input: UpdateWhitelistedAddressInput!) {
  updateWhitelistedAddress(input: $input) {
    id
    companyId
    chain
    address
    label
    status
    createdAt
    updatedAt
  }
}
    `;

export function useUpdateWhitelistedAddressMutation() {
  return Urql.useMutation<UpdateWhitelistedAddressMutation, UpdateWhitelistedAddressMutationVariables>(UpdateWhitelistedAddressDocument);
};
export const GetAuditLogsDocument = gql`
    query getAuditLogs($filter: AuditLogsFilterInput, $pagination: CursorPaginationInput) {
  getAuditLogs(filter: $filter, pagination: $pagination) {
    nodes {
      id
      userId
      user
      action
      entityId
      oldData
      newData
      companyName
      ipAddress
      userAgent
      createdAt
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

export function useGetAuditLogsQuery(options?: Omit<Urql.UseQueryArgs<GetAuditLogsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAuditLogsQuery, GetAuditLogsQueryVariables>({ query: GetAuditLogsDocument, ...options });
};
export const UpdateUserDocument = gql`
    mutation updateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id
    username
    email
    lastActive
    role
    isActive
    isWhitelisted
    companiesCount
    groupsCount
    emailNotifications
  }
}
    `;

export function useUpdateUserMutation() {
  return Urql.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument);
};
export const ResetPasswordDocument = gql`
    mutation resetPassword($userId: String!) {
  resetPassword(userId: $userId) {
    userId
    username
    email
    has2fa
  }
}
    `;

export function useResetPasswordMutation() {
  return Urql.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument);
};
export const ResetMfaDocument = gql`
    mutation resetMFA($userId: String!) {
  resetMFA(userId: $userId) {
    userId
    username
    email
    has2fa
  }
}
    `;

export function useResetMfaMutation() {
  return Urql.useMutation<ResetMfaMutation, ResetMfaMutationVariables>(ResetMfaDocument);
};
export const AssignUserToCompanyDocument = gql`
    mutation assignUserToCompany($input: AssignUserToCompanyInput!) {
  assignUserToCompany(input: $input) {
    id
    username
    email
    lastActive
    role
    isActive
    isWhitelisted
    companiesCount
    groupsCount
    emailNotifications
  }
}
    `;

export function useAssignUserToCompanyMutation() {
  return Urql.useMutation<AssignUserToCompanyMutation, AssignUserToCompanyMutationVariables>(AssignUserToCompanyDocument);
};
export const RemoveUserFromCompanyDocument = gql`
    mutation removeUserFromCompany($input: RemoveUserFromCompanyInput!) {
  removeUserFromCompany(input: $input) {
    id
    username
    email
    lastActive
    role
    isActive
    isWhitelisted
    companiesCount
    groupsCount
    emailNotifications
  }
}
    `;

export function useRemoveUserFromCompanyMutation() {
  return Urql.useMutation<RemoveUserFromCompanyMutation, RemoveUserFromCompanyMutationVariables>(RemoveUserFromCompanyDocument);
};
export const RemoveUserFromGroupDocument = gql`
    mutation RemoveUserFromGroup($input: RemoveUserFromGroupInput!) {
  removeUserFromGroup(input: $input) {
    id
    username
    email
    lastActive
    role
    isActive
    isWhitelisted
    companiesCount
    groupsCount
    emailNotifications
  }
}
    `;

export function useRemoveUserFromGroupMutation() {
  return Urql.useMutation<RemoveUserFromGroupMutation, RemoveUserFromGroupMutationVariables>(RemoveUserFromGroupDocument);
};